import { render, staticRenderFns } from "./work-item-filter.component.vue?vue&type=template&id=358619e0&scoped=true&"
import script from "./work-item-filter.component.vue?vue&type=script&lang=ts&"
export * from "./work-item-filter.component.vue?vue&type=script&lang=ts&"
import style0 from "./work-item-filter.component.vue?vue&type=style&index=0&id=358619e0&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "358619e0",
  null
  
)

export default component.exports